import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface IDailyrentDiscountProps {
  originalPrice: string;
  discountPercent: string;
}

export const DailyrentDiscount = ({ originalPrice, discountPercent }: IDailyrentDiscountProps) => {
  return (
    <div className={styles['discount']} data-testid="dailyrent-discount">
      <span className={styles['original-price']}>
        <UIText2 data-testid="dailyrent-discount-original-price">{originalPrice}</UIText2>
      </span>
      <span className={styles['discount-percent']}>
        <UIText2 color="text-inverted-default" data-testid="dailyrent-discount-percent">
          {discountPercent}
        </UIText2>
      </span>
    </div>
  );
};
